import { Grid2, Paper } from '@mui/material';
import { GridRowParams, GridRowSelectionModel } from '@mui/x-data-grid';

import { useNavigate } from 'react-router';

import { useGetInvoicesListQuery } from 'api/hooks/billing/invoices';
import { DataGrid } from 'app/components';
import { useCurrentURL } from 'utils/hooks/useCurrentURL';
import { useTableQuery } from 'utils/hooks/useTableQuery';

import { useFinanceInvoiceColumns } from '../../components/columns';
import { getDistinctTaxRates } from '../../utils';

interface Props {
  selectedInvoices: GridRowSelectionModel;
  handleSelectionChange: (newSelection: GridRowSelectionModel) => void;
  search: string;
}

export const ExportInvoiceTab = ({ selectedInvoices, handleSelectionChange, search }: Props) => {
  const navigate = useNavigate();
  const currentURL = useCurrentURL();

  const { page, pageSize, sortingModel, handlePaginationChange, handleSortModelChange } =
    useTableQuery({
      defaultSort: [{ field: 'invoiceDate', sort: 'desc' }],
      defaultPageSize: 100,
      sortKey: 'sort_export',
      paginationKeys: { page: 'page_export', pageSize: 'pageSize_export' }
    });

  const { data: invoicesData, isFetching } = useGetInvoicesListQuery({
    params: {
      state: 'APPROVED',
      skip: page * pageSize,
      take: pageSize,
      search: search,
      sort: sortingModel[0]?.field,
      sortOrder: sortingModel[0]?.sort
    }
  });

  const handleRowClick = (params: GridRowParams) => {
    navigate(`/billing/invoices/${params.id}`, {
      state: { back: currentURL }
    });
  };

  return (
    <>
      <Grid2 component={Paper} style={{ height: '75vh' }} container size={12}>
        <DataGrid
          checkboxSelection
          disableRowSelectionOnClick
          disableColumnMenu
          style={{ height: '100%', width: '100%' }}
          loading={isFetching}
          columns={useFinanceInvoiceColumns()}
          rows={invoicesData?.data}
          onRowClick={handleRowClick}
          onRowSelectionModelChange={handleSelectionChange}
          rowSelectionModel={selectedInvoices}
          columnVisibilityModel={{ approvedAt: false, actions: false, pdfPreview: false }}
          getRowClassName={params =>
            getDistinctTaxRates(params.row).length > 1 ? 'invoice-warning' : ''
          }
          rowCount={invoicesData?.count || 0}
          paginationMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={handlePaginationChange}
          sortingMode="server"
          sortModel={sortingModel}
          onSortModelChange={handleSortModelChange}
        />
      </Grid2>
    </>
  );
};
